// En el celular, el inicio es la versión móvil (Martin, 16 oct 2026: el ícono
// del iPhone abría el escritorio). El ícono de "Agregar a inicio" abre la raíz
// (/) — el iPhone toma el manifest con el que cargó la página, no el que /m
// cambia después —, así que la raíz y el login deciden por el tamaño de la
// pantalla. Un link directo a una pantalla de escritorio se respeta.
export const inicioSegunPantalla = () =>
  (window.matchMedia?.('(max-width: 640px)').matches ? '/m' : '/dashboard')
